import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconFileOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.5 3A1.5 1.5 0 0 1 24 4.5V21H0V3zm-21 16.5h21v-15h-21zm5.25-6.75H4.5V15H3V9h4.5v1.5h-3v.75h2.25zM10.5 15H9V9h1.5zm3-1.5h2.25V15H12V9h1.5zm6.75-.75h-1.671v.75h2.417V15H17.25V9H21v1.5h-2.421v.75h1.671z" /></svg>
);
